import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PostInspectionDiySchedulePickup from "../post-inspection-diy-schedule-pickup";
import PostInspectionDiyPickupRtoDocuments from "../post-inspection-diy-pickup-rto-documents";
import { PICKUP_STATUS } from "../../../constants/seller-diy-constants";
import PostInspectionDiyPickupCompleted from "../post-inspection-diy-pickup-completed";
import { NUMBER } from "../../../constants/app-constants";
import Skeleton from "./skeleton";
import { TAB_NAMES } from "../post-inspection-diy-header-v2/constant";

const PostInspectionDiyCarHandover = ({
    postInspectionDiy,
    getCarHandOverDetailsConnect,
    setCarHandoverDetailsConnect,
    setPageLoadingConnect,
    pageLoading
}) => {

    const {
        inspectionResponse,
        activeTab,
        continueLoading
    } = postInspectionDiy || {};

    const {
        pickupStatus,
        isDeliveryApproved
    } = inspectionResponse || {};
    const [isLoading, setIsLoading] = useState(isDeliveryApproved ? true : false);

    useEffect(() => {
        if (isDeliveryApproved) {
            getCarHandOverDetailsConnect(postInspectionDiy).then((res) => {
                setCarHandoverDetailsConnect(res);
                window.setTimeout(() => {
                    setIsLoading(false);
                    setPageLoadingConnect(false);
                }, NUMBER.ONE_THOUSAND_TWENTY_FOUR);
            }).catch(() => {
                if (pageLoading || continueLoading) setPageLoadingConnect(false);
                setIsLoading(false);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) return <Skeleton/>;
    if (pickupStatus === PICKUP_STATUS.PICKUP_COMPLETED) return <PostInspectionDiyPickupCompleted />;
    if (activeTab === TAB_NAMES.DOC_LIST) return <PostInspectionDiyPickupRtoDocuments/>;

    return (
        <PostInspectionDiySchedulePickup />
    );
};

PostInspectionDiyCarHandover.propTypes = {
    postInspectionDiy: PropTypes.object,
    getCarHandOverDetailsConnect: PropTypes.func,
    setCarHandoverDetailsConnect: PropTypes.func,
    setPageLoadingConnect: PropTypes.func,
    pageLoading: PropTypes.bool
};

export default PostInspectionDiyCarHandover;
